(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (() => {})();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();